module.exports = __webpack_public_path__ + "img/logo-estudio-diogo-portugal.jpg";